// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"356":"3363bffb7f79b8d0","2004":"1de3d520a257e3e0","3728":"ba3ea34c1dd1459c","4089":"df419f674e8b8362","5188":"20fda621d9e88832","7573":"59062c788ff8e366"}[chunkId] + ".css";
};